import { render } from "./TransferOrders.vue?vue&type=template&id=c725a456&scoped=true&ts=true"
import script from "./TransferOrders.vue?vue&type=script&lang=ts"
export * from "./TransferOrders.vue?vue&type=script&lang=ts"

import "./TransferOrders.vue?vue&type=style&index=0&id=c725a456&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c725a456"]])

export default __exports__